module.exports = __webpack_public_path__ + "img/auth.e93816ab.png";